/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { showSuccess } from "~/components";
import {
  Customer,
  DatadogOrganization,
} from "~/components/BasicCustomerInfo/types";
import { useShowError } from "~/components/Error/useShowError";
import { InlineEditMultiSelect } from "~/components/InlineEdit/InlineEditMultiSelect";
import { Loading } from "~/components/Utils/Loading";
import { generateActionSuccessText, useAxios } from "~/tools";

type Props = {
  customer: Customer;
  ddOrgs: DatadogOrganization[];
  fetchCustomer: () => Promise<void>;
  canEdit: boolean;
};

export default function ({ customer, ddOrgs, fetchCustomer, canEdit }: Props) {
  const { showError } = useShowError();
  const { Axios } = useAxios();

  if (!ddOrgs.length) {
    return <Loading />;
  }

  const submit = async (orgIds: string[]) => {
    const updateData = {
      ...customer,
      toolsAndIntegrations: {
        ...customer.toolsAndIntegrations,
        datadogOrganizations: orgIds,
      },
    };

    try {
      await Axios().put(`/customers/${customer.id}`, updateData);
      showSuccess(
        generateActionSuccessText(`Customer ${customer.name}`)()("updated")()
      );
    } catch (e) {
      showError(e.response);
    }

    return fetchCustomer();
  };

  return (
    <InlineEditMultiSelect
      options={ddOrgs.map((org) => org.name)}
      defaultValue={customer.toolsAndIntegrations?.datadogOrganizations || []}
      onSubmit={submit}
      canEdit={canEdit}
    />
  );
}
